import React from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import Spinner from './spinner'
import defaultStyles from './themes/default/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import thebalance1 from './themes/thebalance1/styles.module.scss'
import investopedia1 from './themes/investopedia1/styles.module.scss'
import forbes1 from './themes/forbes1/styles.module.scss'
import yahoo1 from './themes/yahoo1/styles.module.scss'
import homes1 from './themes/homes1/styles.module.scss'
import insider from './themes/insider/styles.module.scss'

import withStyles from '@cred/react-theme'

/**
 * @visibleName CTA Button
 */
const CtaButton = (compProps) => {
  const {
      href,
      primary,
      transparent,
      blank,
      fullWidth,
      className,
      small,
      disabled,
      disabledStyle,
      submitting,
      onClick,
      rel,
      navigate,
      analytics,
      match,
      location,
      history,
      staticContext,
      analyticsContexts,
      analyticsOptions,
      overwriteContexts,
      styles = defaultStyles,
      dispatch,
      controlFormData,
      formData,
      formName,
      type,
      loading,
      children,
      keepPrimaryColorWhenDisabled,
      tertiary,
      ...props
    } = compProps,
    cls = [styles.cta],
    onClickHandler = (proxy) => {
      const { onClick, disabled, disabledStyle } = compProps

      if (onClick) {
        const additionalEventData = { disabled, disabledStyle }

        onClick(proxy, additionalEventData)
      }
    }

  props.target = blank ? '_blank' : '_self'

  if (className) {
    cls.push(className)
  }

  if (primary && !tertiary) {
    cls.push(styles.primary)
  } 
  
  if(!primary && !tertiary) {
    cls.push(styles.secondary)
  }

  if (tertiary) {
    cls.push(styles.tertiary)
  }

  if (transparent) {
    cls.push(styles.transparent)
  }

  if (fullWidth) {
    cls.push(styles.fullWidth)
  }

  if (small) {
    cls.push(styles.small)
  }

  if ((disabled || disabledStyle) && !keepPrimaryColorWhenDisabled) {
    cls.push(styles.disabled)
  }

  return href ? (
    <Font
      element="a"
      weight="semiBold"
      href={href}
      onClick={onClickHandler}
      className={cls.join(' ')}
      rel={rel}
      {...props}
    >
      {children}
      {loading && <Spinner small={small} className="ml-8" />}
    </Font>
  ) : (
    <Font
      element="button"
      weight="semiBold"
      onClick={onClickHandler}
      className={cls.join(' ')}
      disabled={disabled}
      elementProps={{ type }}
      {...props}
    >
      {children}
      {loading && <Spinner small={small} className="ml-8" />}
    </Font>
  )
}

CtaButton.propTypes = {
  primary: PropTypes.bool,
  transparent: PropTypes.bool,
  fullWidth: PropTypes.bool,
  blank: PropTypes.bool,
  small: PropTypes.bool,
  rel: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit']),
  disabled: PropTypes.bool,
  disabledStyle: PropTypes.bool,
  history: PropTypes.object,
  styles: PropTypes.object,
  loading: PropTypes.bool,
  keepPrimaryColorWhenDisabled: PropTypes.bool,
  tertiary: PropTypes.bool
}

CtaButton.defaultProps = {
  primary: true,
  transparent: false,
  fullWidth: false,
  blank: false,
  small: false,
  rel: '',
  type: 'button',
  disabled: false,
  disabledStyle: false,
  history: {},
  loading: false,
  keepPrimaryColorWhenDisabled: false,
  tertiary: false
}

CtaButton.displayName = 'CtaButton'

export { CtaButton as CtaButtonNoHoc }

export default withStyles(defaultStyles, {
  fox1,
  thebalance1,
  investopedia1,
  forbes1,
  yahoo1,
  homes1,
  insider
})(CtaButton)
